import { jsx, jsxs } from "react/jsx-runtime";
import Draggable from "react-draggable";
import styles from "./index.module";
import useExperiments from "../../../../hooks/useExperiments";
import useWindowPath from "../../../../hooks/useWindowPath";
import useGeneralConfigs from "../../../../hooks/useGeneralConfigs";
const DevTool = (props) => {
  var _a;
  const { internalExperiments, activeExperiments, inactiveExperiments, listeningExperiments } = useExperiments();
  const { uid, btm } = useGeneralConfigs();
  const path = useWindowPath();
  return /* @__PURE__ */ jsx(Draggable, { children: /* @__PURE__ */ jsxs("div", { className: styles.recordingBanner, children: [
    /* @__PURE__ */ jsx("div", { className: styles.bannerTitle, children: /* @__PURE__ */ jsxs("span", { children: [
      " ",
      props.recordingStatus,
      " "
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: styles.debugId, children: [
      "Current UID: ",
      uid
    ] }),
    /* @__PURE__ */ jsxs("div", { className: styles.debugId, children: [
      "Current BPoint: ",
      btm ? btm == null ? void 0 : btm.getCurrentPageBId(path) : path
    ] }),
    /* @__PURE__ */ jsx("div", { className: styles.debugId, children: "Relevant Experiments:" }),
    /* @__PURE__ */ jsx("div", { className: styles.bannerDescription, children: (_a = internalExperiments == null ? void 0 : internalExperiments.relevantExperiments) == null ? void 0 : _a.map((exp) => {
      return /* @__PURE__ */ jsxs("div", { style: { border: "1px solid black" }, children: [
        "Experiment ",
        exp.experimentId,
        /* @__PURE__ */ jsxs("div", { children: [
          "Page Whitelist: ",
          exp.enablesPages.toString()
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "UID Whitelist: ",
          exp.uids
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Start Triggers: ",
          exp.recordingStartBtmPoints
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Journey Entry: ",
          exp.journeyEntryPage
        ] })
      ] });
    }) }),
    /* @__PURE__ */ jsx("div", { className: styles.debugId, children: "Active Experiments:" }),
    /* @__PURE__ */ jsx("div", { className: styles.bannerDescription, children: activeExperiments == null ? void 0 : activeExperiments.map((exp) => {
      return /* @__PURE__ */ jsxs("div", { style: { border: "1px solid black" }, children: [
        "Experiment ",
        exp.experimentId,
        /* @__PURE__ */ jsxs("div", { children: [
          "Page Whitelist: ",
          exp.enablesPages.toString()
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "UID Whitelist: ",
          exp.uids
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Start Triggers: ",
          exp.recordingStartBtmPoints
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Journey Entry: ",
          exp.journeyEntryPage
        ] })
      ] });
    }) }),
    /* @__PURE__ */ jsx("div", { className: styles.debugId, children: "Inactive Experiments:" }),
    /* @__PURE__ */ jsx("div", { className: styles.bannerDescription, children: inactiveExperiments == null ? void 0 : inactiveExperiments.map((exp) => {
      return /* @__PURE__ */ jsxs("div", { style: { border: "1px solid black" }, children: [
        "Experiment ",
        exp.experimentId,
        /* @__PURE__ */ jsxs("div", { children: [
          "Page Whitelist: ",
          exp.enablesPages.toString()
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "UID Whitelist: ",
          exp.uids
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Start Triggers: ",
          exp.recordingStartBtmPoints
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Journey Entry: ",
          exp.journeyEntryPage
        ] })
      ] });
    }) }),
    /* @__PURE__ */ jsx("div", { className: styles.debugId, children: "Listening Experiments:" }),
    /* @__PURE__ */ jsx("div", { className: styles.bannerDescription, children: listeningExperiments == null ? void 0 : listeningExperiments.map((exp) => {
      return /* @__PURE__ */ jsxs("div", { style: { border: "1px solid black" }, children: [
        "Experiment ",
        exp.experimentId,
        /* @__PURE__ */ jsxs("div", { children: [
          "Page Whitelist: ",
          exp.enablesPages.toString()
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          "UID Whitelist: ",
          exp.uids
        ] }),
        /* @__PURE__ */ jsxs("div", { children: [
          " Start Triggers: ",
          exp.recordingStartBtmPoints
        ] })
      ] });
    }) })
  ] }) });
};
var dev_tool_popup_default = DevTool;
export {
  DevTool,
  dev_tool_popup_default as default
};
